<app-explicit-confirmation
  [explicitConfirmationText]="
    explicitConfirmationConfig.explicitConfirmationText
  "
  [title]="explicitConfirmationConfig.title"
  [cancelButtonText]="explicitConfirmationConfig.cancelButtonText"
  [confirmButtonText]="explicitConfirmationConfig.confirmButtonText"
  [inputLabelSuffix]="explicitConfirmationConfig.inputLabelSuffix"
  [width]="'80%'"
  (confirm)="onConfirm($event)"
  class="move-users-confirmation-dialog"
>
  <div optional-template class="move-users-confirmation-dialog-content">
    <!-- stylized messages -->
    <div class="messages-container">
      <span class="material-icons">warning</span>
      <span>
        <markdown
          [data]="'MoveForms.UserMove.WarningMessage' | translate"
        ></markdown>
      </span>
    </div>
    <div class="messages-container billable-org-warning" *ngIf="showBillableOrgWarning">
      <span class="material-icons">warning</span>
      <div class="warning-text">
        <span>{{ 'MoveForms.UserMove.BillableOrgWarningMessage' | translate }}</span>
      </div>
    </div>
    <ag-grid-angular
      style="height: 100%; width: 100%"
      class="ag-theme-material ag-theme-material-cell-height"
      [rowData]="selectedUsers"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [suppressMovableColumns]="true"
      aria-label="User grid"
    >
    </ag-grid-angular>
  </div>
</app-explicit-confirmation>
